/**
 *
 */
jQuery.fn.extend(jqueryDirectFunctions);